











export default
    computed:
        year_count: ->
            return @$store.getters['data/year_count']

        year_range: ->
            year_min = @$store.state.filter.range.year.lower_bound
            year_max = @$store.state.filter.range.year.upper_bound
            return [year_max..year_min]

